import React, { useEffect, useState } from "react";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import medicGeekApi from "../../config/axiosConfig";
import ConsultaForm from "./../Consulta/ConsultaForm";
import PacienteForm from "./PacienteForm";
import "./../../styles/FormPro.css";

const PacientesList = ({
  setCurrentForm,
  currentForm,
  setSelectedPaciente,
}) => {
  const [pacientes, setPacientes] = useState([]);
  const [ultimaConsulta, setUltimaConsulta] = useState(0);
  // Skeleton
  const [loading, setLoading] = useState(true);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const pacientesPerPage = 10;
  const [selectedPacienteLocal, setSelectedPacienteLocal] = useState(null);
  const [lastPcteId, setLastPcteId] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const { newPcteId } = useParams();
  const [selected, setSelected] = useState(false);
  const navigate = useNavigate();
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [showInactive, setShowInactive] = useState(false); // Inicialmente en falso para mostrar solo "Activo"

  
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Iniciar la carga
      try {
        const response = await medicGeekApi.get(
          `/patients?search=${searchTerm}`,
          {
            params: {
              $or: [
                { pcteNom: { $regex: searchTerm, $options: "i" } },
                { pcteNom2: { $regex: searchTerm, $options: "i" } },
                { pcteApe1: { $regex: searchTerm, $options: "i" } },
                { pcteApe2: { $regex: searchTerm, $options: "i" } },
              ],
            },
          }
        );
        
        // Filtrar solo pacientes con estatus "Activo" o "Inactivo"
        const filteredPacientes = response.data.filter(
          (paciente) => paciente.estatus === "Activo" || paciente.estatus === "Inactivo"
        );
  
        const sortedPacientes = filteredPacientes.sort((a, b) => a.pcteId - b.pcteId);
        setPacientes(sortedPacientes);
  
        // Obtener el último pcteId
        const lastPcteId = sortedPacientes.length > 0 ? sortedPacientes[sortedPacientes.length - 1].pcteId : 0;
        setLastPcteId(lastPcteId);
        setHasLoaded(true);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false); // Finalizar carga
      }
    };
    fetchData();
  }, [searchTerm]);

  const handleSearchTermChange = (e) => {
    setSearchTerm(e.target.value);
    setPageNumber(0);
  };

  const handleNewPacienteClick = () => {
    const newPcteId = parseInt(lastPcteId, 10) + 1;
    return <Navigate to={`/patients/new/${newPcteId}`} />;
  };

  const pageCount = Math.ceil(pacientes.length / pacientesPerPage);

  const handlePageChange = ({ selected }) => {
    setPageNumber(selected);
  };

  const sortedPacientes = [...pacientes].sort((a, b) => {
    if (sortConfig.key === null) return 0; // No ordenar si no se ha seleccionado una columna
  
    let aValue = a[sortConfig.key];
    let bValue = b[sortConfig.key];
  
    // Convertir a números si ambos valores son numéricos
    if (!isNaN(aValue) && !isNaN(bValue)) {
      aValue = Number(aValue);
      bValue = Number(bValue);
    }
  
    if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
    if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
    return 0;
  });
  
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const displayedPacientes = [...sortedPacientes]
  .filter((paciente) => {

    const search = searchTerm
      .toLowerCase()
      .trim()
      .replace(/\s+/g, " ");

    const fullName = [
      paciente.pcteNom,
      paciente.pcteNom2,
      paciente.pcteApe1,
      paciente.pcteApe2,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase()
      .trim()
      .replace(/\s+/g, " ");

    const searchWords = search
      .split(" ")
      .filter(Boolean);

    const nameWords = fullName
      .split(" ")
      .filter(Boolean);

    // Copia para evitar reutilizar la misma palabra
    const availableWords = [...nameWords];

    const nameMatches =
      search === "" ||
      searchWords.every((word) => {

        // Buscar una palabra que COMIENCE con lo escrito
        const index = availableWords.findIndex(
          (nameWord) =>
            nameWord.startsWith(word)
        );

        if (index === -1) {
          return false;
        }

        // Consumir esta coincidencia
        // para que no pueda reutilizarse
        availableWords.splice(index, 1);

        return true;
      });

    const estatusMatches = showInactive
      ? paciente.estatus === "Activo" ||
        paciente.estatus === "Inactivo"
      : paciente.estatus === "Activo";

    return nameMatches && estatusMatches;
  })

  .sort(
    (a, b) =>
      Number(b.pcteId) - Number(a.pcteId)
  )

  .slice(
    pageNumber * pacientesPerPage,
    (pageNumber + 1) * pacientesPerPage
  );

  const handleCloseForm = () => {
    setShowForm(false);
  };

  const updatePacientesList = () => {
    medicGeekApi
      .get("/patients")
      .then((response) => {
        setPacientes(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleOpenConsultaForm = async (paciente) => {
    try {
      setSelectedPaciente(paciente);
      setCurrentForm("consultaForm");
    } catch (error) {
      console.error("Error al cargar la última consulta:", error);
    }
  };

  const handleOpenHistoryForm = async (paciente) => {
    try {
      setSelectedPaciente(paciente);

      setCurrentForm("consultaForm");
      setSelected(true);

      // campos a enviar a consultas

      navigate(`/patient/${paciente?.pcteId}/patient-history`);
    } catch (error) {
      console.error("Error al cargar la última consulta:", error);
    }
  };

  const SkeletonTableRow = () => (
    <tr>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "60px" }}></div>
      </td>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "150px" }}></div>
      </td>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "100px" }}></div>
      </td>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "70px" }}></div>
      </td>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "200px" }}></div>
      </td>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "100px" }}></div>
      </td>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "60px" }}></div>
      </td>
    </tr>
  );

  // Para pantallas pequeñas, cambia la tabla por tarjetas
  return (
    <div className="pro-container">
      {showForm ? (

        <PacienteForm
          onCloseForm={handleCloseForm}
          pacienteToEdit={selectedPacienteLocal}
          updatePacientesList={updatePacientesList}
          setSelectedPaciente={setSelectedPacienteLocal}
        />
      ) : (
        <>
          {/* ================================================= */}
          {/* HEADER */}
          {/* ================================================= */}
          <div className="pro-header">

            <div>

              <h2 className="pro-title">
                Pacientes
              </h2>

              <p className="pro-subtitle">
                Gestión y administración de pacientes
              </p>

            </div>

            <div className="pro-actions">

              {/* SEARCH */}
              <div className="pro-search">

                <i className="bi bi-search"></i>

                <input
                  type="search"
                  placeholder="Buscar paciente..."
                  value={searchTerm}
                  onChange={handleSearchTermChange}
                />

              </div>

              {/* BUTTON */}
              <Link to={`/patients/new/${newPcteId}`}>

                <button
                  type="button"
                  className="pro-btn-primary"
                  title="Crear Nuevo Paciente"
                  onClick={handleNewPacienteClick}
                >

                  <i className="bi bi-person-plus-fill"></i>

                  Nuevo Paciente

                </button>

              </Link>

            </div>

          </div>
          {/* ================================================= */}
          {/* FILTERS */}
          {/* ================================================= */}
          <div className="pro-filters">
            <label className="modern-checkbox">
              <input
                type="checkbox"
                checked={showInactive}
                onChange={() =>
                  setShowInactive((prev) => !prev)
                }
              />
              <span className="checkmark"></span>
              Mostrar Inactivos
            </label>
          </div>
          {/* ================================================= */}
          {/* CARD */}
          {/* ================================================= */}

          <div className="pro-card">
            {/* ================================================= */}
            {/* TABLE */}
            {/* ================================================= */}

            <div className="table-responsive">

              {/* DESKTOP */}
              <div className="d-none d-md-block">

                <table className="table pro-table align-middle">
                  <thead>
                    <tr>
                      <th onClick={() => handleSort("pcteId")}>
                        Expediente
                      </th>
                      <th onClick={() => handleSort("pcteNom")}>
                        Paciente
                      </th>
                      <th onClick={() => handleSort("pcteEd")}>
                        Fecha Nacimiento
                      </th>
                      <th onClick={() => handleSort("pcteSx")}>
                        Género
                      </th>
                      <th>
                        Dirección
                      </th>
                      <th onClick={() => handleSort("pcteNumDoc")}>
                        Documento
                      </th>
                      <th className="text-center">
                        Acciones
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      Array.from({ length: 12 }).map((_, index) => (
                        <tr key={index}>
                          <td>
                            <div className="skeleton-line"></div>
                          </td>
                          <td>
                            <div className="skeleton-line"></div>
                          </td>
                          <td>
                            <div className="skeleton-line"></div>
                          </td>
                          <td>
                            <div className="skeleton-line"></div>
                          </td>
                          <td>
                            <div className="skeleton-line"></div>
                          </td>
                          <td>
                            <div className="skeleton-line"></div>
                          </td>
                          <td>
                            <div className="skeleton-line"></div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      displayedPacientes.map((paciente) => (
                        <tr key={paciente.pcteId}>
                          {/* EXPEDIENTE */}
                          <td>
                            <span className="pro-badge primary">
                              Exp-
                              {paciente.pcteId
                                .toString()
                                .padStart(6, "0")}
                            </span>
                          </td>
                          {/* PACIENTE */}
                          <td>
                            <div className="patient-info">
                              <div className="patient-avatar">
                                {paciente.pcteNom?.charAt(0)}
                              </div>
                              <div>
                                <div className="patient-name">
                                  {paciente.pcteNom}{" "}
                                  {paciente.pcteNom2}{" "}
                                  {paciente.pcteApe1}{" "}
                                  {paciente.pcteApe2}
                                </div>
                                <div className="patient-id">
                                  ID #{paciente.pcteId}
                                </div>
                              </div>
                            </div>
                          </td>
                          {/* FECHA */}
                          <td>
                            {paciente.pcteEd}
                          </td>
                          {/* GENERO */}
                          <td>
                            <span className="pro-badge info">
                              {paciente.pcteSx}
                            </span>
                          </td>
                          {/* DIRECCION */}
                          <td
                            className="truncate-text"
                            data-bs-toggle="tooltip"
                            title={paciente.pcteDir}
                          >
                            {paciente.pcteDir?.length > 35
                              ? `${paciente.pcteDir.slice(0, 35)}...`
                              : paciente.pcteDir}
                          </td>
                          {/* DOCUMENTO */}
                          <td>
                            {paciente.pcteNumDoc}
                          </td>
                          {/* ACTIONS */}
                          <td>
                            <div className="pro-table-actions">
                              {/* CONSULTA */}
                              <Link
                                to={`/patients/${paciente.pcteId}/encounters/${ultimaConsulta}`}
                              >
                                <button
                                  type="button"
                                  className="pro-action-btn primary"
                                  title="Nueva Consulta"
                                  onClick={() =>
                                    handleOpenConsultaForm(paciente)
                                  }
                                >
                                  <i className="bi bi-file-earmark-plus-fill"></i>
                                </button>
                              </Link>
                              {/* EDIT */}
                              <Link
                                to={`/patients/edit/${paciente.pcteId}`}
                              >

                                <button
                                  type="button"
                                  className="pro-action-btn warning"
                                  title="Editar"
                                >

                                  <i className="bi bi-pencil-square"></i>

                                </button>

                              </Link>

                              {/* HISTORIAL */}
                              <button
                                type="button"
                                className="pro-action-btn info"
                                title="Ver Historial Clínico"
                                onClick={() =>
                                  handleOpenHistoryForm(paciente)
                                }
                              >

                                <i className="bi bi-folder2-open"></i>

                              </button>

                            </div>

                          </td>

                        </tr>

                      ))

                    )}

                  </tbody>

                </table>

              </div>

              {/* ================================================= */}
              {/* MOBILE */}
              {/* ================================================= */}

              <div className="d-md-none p-3">

                <div className="row g-3">

                  {loading ? (

                    Array.from({ length: 5 }).map((_, index) => (

                      <div
                        className="col-12"
                        key={index}
                      >

                        <div className="mobile-card">

                          <div className="card-body">

                            <div className="skeleton-line mb-3"></div>
                            <div className="skeleton-line mb-3"></div>
                            <div className="skeleton-line mb-3"></div>
                            <div className="skeleton-line"></div>

                          </div>

                        </div>

                      </div>

                    ))

                  ) : (

                    displayedPacientes.map((paciente) => (

                      <div
                        className="col-12"
                        key={paciente.pcteId}
                      >

                        <div className="mobile-card">

                          <div className="card-body">

                            {/* TOP */}
                            <div className="mobile-card-top">

                              <div className="patient-info">

                                <div className="patient-avatar">

                                  {paciente.pcteNom?.charAt(0)}

                                </div>

                                <div>

                                  <div className="patient-name">

                                    {paciente.pcteNom}{" "}
                                    {paciente.pcteApe1}

                                  </div>

                                  <div className="patient-id">

                                    Exp-
                                    {paciente.pcteId
                                      .toString()
                                      .padStart(6, "0")}

                                  </div>

                                </div>

                              </div>

                            </div>

                            {/* CONTENT */}
                            <div className="mobile-card-content">

                              <p>
                                <strong>Fecha:</strong>{" "}
                                {paciente.pcteEd}
                              </p>

                              <p>
                                <strong>Género:</strong>{" "}
                                {paciente.pcteSx}
                              </p>

                              <p>
                                <strong>Documento:</strong>{" "}
                                {paciente.pcteNumDoc}
                              </p>

                              <p>
                                <strong>Dirección:</strong>{" "}
                                {paciente.pcteDir}
                              </p>

                            </div>

                            {/* ACTIONS */}
                            <div className="pro-table-actions">

                              <Link
                                to={`/patients/${paciente.pcteId}/encounters/${ultimaConsulta}`}
                              >

                                <button
                                  className="pro-action-btn primary"
                                  onClick={() =>
                                    handleOpenConsultaForm(paciente)
                                  }
                                >

                                  <i className="bi bi-file-earmark-plus-fill"></i>

                                </button>

                              </Link>

                              <Link
                                to={`/patients/edit/${paciente.pcteId}`}
                              >

                                <button className="pro-action-btn warning">

                                  <i className="bi bi-pencil-square"></i>

                                </button>

                              </Link>

                              <button
                                className="pro-action-btn info"
                                onClick={() =>
                                  handleOpenHistoryForm(paciente)
                                }
                              >

                                <i className="bi bi-folder2-open"></i>

                              </button>

                            </div>

                          </div>

                        </div>

                      </div>

                    ))

                  )}

                </div>

              </div>

            </div>
            {/* ================================================= */}
            {/* PAGINATION */}
            {/* ================================================= */}
            {!showForm && (
              <div className="pro-pagination">
                <nav>
                  <ul className="pagination modern-pagination">
                    {/* PREVIOUS */}
                    <li
                      className={`page-item ${
                        pageNumber === 0
                          ? "disabled"
                          : ""
                      }`}
                    >

                      <button
                        className="page-link"
                        onClick={() =>
                          handlePageChange({
                            selected: pageNumber - 1,
                          })
                        }
                      >

                        <i className="bi bi-chevron-left"></i>

                      </button>

                    </li>
                    {/* NUMBERS */}
                    {Array.from(
                      {
                        length: Math.min(pageCount, 10),
                      },
                      (_, index) => (

                        <li
                          key={index}
                          className={`page-item ${
                            pageNumber === index
                              ? "active"
                              : ""
                          }`}
                        >

                          <button
                            className="page-link"
                            onClick={() =>
                              handlePageChange({
                                selected: index,
                              })
                            }
                          >

                            {index + 1}

                          </button>

                        </li>

                      )
                    )}
                    {/* NEXT */}
                    <li
                      className={`page-item ${
                        pageNumber === pageCount - 1
                          ? "disabled"
                          : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() =>
                          handlePageChange({
                            selected: pageNumber + 1,
                          })
                        }
                      >
                        <i className="bi bi-chevron-right"></i>
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            )}
          </div>
          {/* ================================================= */}
          {/* CONSULTA FORM */}
          {/* ================================================= */}

          {currentForm === "consultaForm" &&
            selectedPacienteLocal && (

              <div className="main-content">

                <ConsultaForm
                  onCloseForm={handleCloseForm}
                  paciente={selectedPacienteLocal}
                  setCurrentForm={setCurrentForm}
                />

              </div>

            )}
        </>
      )}
    </div>
  );
};

export default PacientesList;
